import React, {useState, useContext, useEffect} from "react";
import Dropdown from 'react-dropdown';
import {useTranslation} from 'react-i18next';
import GlobalRulesContext from './RulesContext';
import { getNodeById, AddNode } from './RulesData';
import './RulesTableStyles.scss';

const RuleCondtion = (props) => {
    const [t] = useTranslation();
    const logicalOperators = [
      { value: "all", label: t("views.interview.rules_editor.and") },
      { value: "any", label: t("views.interview.rules_editor.or") },
    ]

    const [isDeleteAllowed, setIsDeleteAllowed] = useState(false);

    let {rules, updateRules} = useContext(GlobalRulesContext);
    let [selectedCondition, setSelectedCondition] = useState(null);

    let currentNode = props.nodeInfo;
    let parent;

    const onDeleteClicked = (event) =>{
      const index = parent.children.findIndex(node => node.id === currentNode.id);
      if (index >= 0) {
        parent.children.splice(index, 1);
      }
      updateRules(rules, parent.id);
    };

    const onConditionSelect = (condition) => {
      if (currentNode) {
        currentNode.condition = condition.value;
        updateRules(rules, currentNode.id);
        setSelectedCondition(condition.value);
      }
    }

    useEffect(() => {
      if (currentNode && currentNode.parent) {
        parent = currentNode.parent;
      }

      if (currentNode && 
          currentNode.children && 
          currentNode.children.length > 0) {
        if (currentNode.children[0].getNodeType() === "AddNode") {
          setIsDeleteAllowed(true);
        } else {
          setIsDeleteAllowed(false);
        }
      } else {
        setIsDeleteAllowed(false);
      }
      if (currentNode.condition) {
        setSelectedCondition(currentNode.condition);
      }
    });
    
    const getSelectedCondition = (value) => {
      let retVal = null;
      if (value) {
        let fileteredArray = logicalOperators.filter(val => val.value === value);
        if (fileteredArray) {
          retVal = fileteredArray[0];
        }
      }
      return retVal;
    }
    
    return (
      <div className="single-line-container">
        <Dropdown onChange={onConditionSelect} 
            options={ logicalOperators }
            value = {getSelectedCondition(selectedCondition)}
            placeholder={t('views.interview.rules_editor.condition')} />
        <div className="action-button">
          <button className="btn btn-danger"
                  disabled={!isDeleteAllowed}
                  onClick={onDeleteClicked}>
            <i className="fa fa-trash"></i>
          </button>
        </div>
      </div>
    );
}

export default RuleCondtion;